import { createFileRoute } from '@tanstack/react-router'
import { QuoteEditor } from '@/routes/sales/quotes/-QuoteEditor'

export const Route = createFileRoute('/sales/quotes/$id/')({
  component: QuoteDetailPage,
})

function QuoteDetailPage() {
  const { id } = Route.useParams()
  return <QuoteEditor id={id} />
}
